import { matchPath } from 'react-router-dom';

export const CONSENT_SURFACE_DASHBOARD = 'dashboard';

const CONSENT_SURFACE_FLOW_PREFIX = 'flow:';

/** Mirrors the matching routes in `Router.tsx`; keep in step if either route is renamed. */
const DASHBOARD_PATHS = ['/', '/folders/:folderId'];
const FLOW_PATH = '/flow/:recipeId';
const TOOL_PATH = '/tool/:toolId';

export function getConsentSurfaceId(pathname: string): string | null {
  if (DASHBOARD_PATHS.some((path) => matchPath({ path, end: true }, pathname))) {
    return CONSENT_SURFACE_DASHBOARD;
  }

  const flowMatch = matchPath({ path: FLOW_PATH, end: true }, pathname);
  if (flowMatch?.params.recipeId) {
    return `${CONSENT_SURFACE_FLOW_PREFIX}${flowMatch.params.recipeId}`;
  }

  const toolMatch = matchPath({ path: TOOL_PATH, end: true }, pathname);
  if (toolMatch?.params.toolId) {
    return `tool:${toolMatch.params.toolId}`;
  }

  return null;
}

/** True for a `/flow/:recipeId` surface, the only kind that waits for the canvas before showing. */
export function isWorkflowConsentSurface(surfaceId: string | null): boolean {
  return surfaceId !== null && surfaceId.startsWith(CONSENT_SURFACE_FLOW_PREFIX);
}
